import { FilterOutlined } from '@ant-design/icons';
import type { ReferenceType } from '@cult/domain';
import { Select } from 'antd';
import { MUTED_ICON_COLOR } from '../../../../theme/tokens';
import { useReferenceItems } from '../../hooks';

type Props = {
  type: ReferenceType;
  value: string[];
  onChange: (ids: string[]) => void;
  placeholder: string;
};

/** Multiselect filter over the active items of one reference type. */
export const ReferenceFilter = ({ type, value, onChange, placeholder }: Props) => {
  const itemsQuery = useReferenceItems(type);

  return (
    <Select
      mode="multiple"
      value={value}
      onChange={onChange}
      allowClear
      maxTagCount="responsive"
      placeholder={placeholder}
      prefix={<FilterOutlined style={{ color: MUTED_ICON_COLOR }} />}
      loading={itemsQuery.isPending}
      options={itemsQuery.data?.map((item) => ({ value: item.id, label: item.name })) ?? []}
      style={{ width: 220 }}
    />
  );
};
